const Fetcher = require('od-modules/utils/fetcher');

const getUrl = () => Odigeo.Settings.getProperty('ancillariesUrlFormatter')('commitFromShoppingCart');

class Committer {
    commit(data = {}) {
        return new Promise((resolve) => {
            Fetcher.post(getUrl(), data).json()
                .then((data) => resolve({success: true, data}))
                .catch((data) => resolve({success: false, data}));
        });
    }
}

module.exports = new Committer();
